import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { DictionaryContractModificationReason } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { contractModificationsWizardSteps } from 'src/app/models/wizard-enum';

@Component({
  selector: 'contract-modification-reason',
  templateUrl: './request-reason.component.html',
  styleUrls: ['./request-reason.component.scss'],
  standalone: false,
})
export class RequestReasonComponent implements OnInit {
  wizardStepsEnum = contractModificationsWizardSteps;

  @Input() contractModificationRequest: app.models.ContractModificationRequest;
  @Input() DICTIONARY_CONTRACT_MODIFICATION_TYPE: app.models.DictionaryContractModificationRequestType;
  @Input() DICTIONARY_REIMBURSEMENT_TYPE: app.models.DictionaryReimbursementType;
  @Input() contractModificationRequestReasonDatasource: app.models.DictionaryContractModificationRequestReason[];
  @Input() firstQuestionFormGroup: FormGroup;

  @Input() nextStepHandler: any;
  @Input() deleteFileHandler: any;
  @Input() uploadFilesHandler: any;

  public isNextButtonDisabled: boolean = true;

  ngOnInit() {
    this.isNextButtonDisabled = this.firstQuestionFormGroup.invalid;
    this.firstQuestionFormGroup.statusChanges.subscribe(x => (this.isNextButtonDisabled = x !== 'VALID'));

    this.firstQuestionFormGroup.controls.answear.valueChanges.subscribe(res => {
      if (res) {
        const selectedReason = this.contractModificationRequestReasonDatasource.find(x => x.id === res);
        if (selectedReason?.code.includes(DictionaryContractModificationReason.OTHER)) {
          this.firstQuestionFormGroup.controls.reason.setValidators([Validators.required]);
          this.firstQuestionFormGroup.controls.reason.updateValueAndValidity();
        } else {
          this.firstQuestionFormGroup.controls.reason.clearValidators();
          this.firstQuestionFormGroup.controls.reason.updateValueAndValidity();
        }
      }
    });
  }
}
